import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MiningTileRewardBtc = ({ data, formatLargeNumber, animate }) => {
  const numberValue = data?.ts11?.rewards144?.totalReward != null
    ? `${formatLargeNumber(data.ts11.rewards144.totalReward, 2, false) + ' Sats' ?? "Loading..."}`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Rewards BTC 24h" value={numberValue} />
    </ThemedFlex>
  );
};
